function run($injector, BBModel) {
    'ngInject';

    const models = [
        'Booking',
        'Member',
        'PaymentItem',
        'Purchase',
        'PurchaseItem',
        'Wallet',
        'WalletLog',
        'WalletPurchaseBand'
    ];

    BBModel['Member'] = {};
    for (const model of models) {
        BBModel['Member'][model] = $injector.get(`Member.${model}Model`);
    }
}

export default run;


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/member/main.run.js